import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.99998 1.74968L0.833313 10H3.33331V17.5H8.33331V12.5H11.6666V17.5H16.6666V10H19.1666L9.99998 1.74968Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgHome);
export default ForwardRef;
